import React, { useEffect } from "react";
import LoadingSpinner from "../../../../atoms/loading-spinner";
import Explorer from "../../../../../data-containers/explorer";
import LocationDetails from "../../../../../data-containers/location-details";
import DynamicCell from "../../../../atoms/table/dynamic-cell";
import ErrorWithTooltip from "../../../../atoms/error-with-tooltip";
import HistoricalTotals from "./historical-totals";

function ConsumptionContent(props) {
  // TODO put all of this functionality into a custom hook
  const { dateRange } = Explorer.useContainer();
  const { getDetail, fetchHistoricalForLocation } = LocationDetails.useContainer();
  const { id } = props.rowData;
  const { historical } = getDetail(id) || {};
  const { [dateRange.id]: { data, loading, error }={} } = historical || {};

  function hasConsumptionData(){
    try {
      const { totals } = data;
      return !!totals[0].find(({type}) => type === 'cons');
    }
    catch(_){}
    return false;
  }

  useEffect(() => {
    if (id && dateRange?.id) {
      fetchHistoricalForLocation(id, { dateRange });
    }
  }, [id, dateRange.id]);

  if (loading) {
    return <LoadingSpinner className="inline" />;
  }
  if (error) {
    return <ErrorWithTooltip error={error} />;
  }
  if (!hasConsumptionData()){
    return <div className="na">—</div>;
  }
  if (data) {
    return <HistoricalTotals historicalData={data} type="cons" />
  }
  return <div className="na">—</div>;
}

export default DynamicCell(ConsumptionContent);
